/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "8vuu2yzow2",
            "endpoint": "https://8vuu2yzow2.execute-api.eu-west-2.amazonaws.com/flashcards",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:98306b4e-16b1-4dfc-8d98-9aae04c90953",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_0jtrUQ84g",
    "aws_user_pools_web_client_id": "5ve2ahpvh1enu6go0patr9s47j",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "recallTable-flashcards",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
